export default "__VITE_ASSET__1755a69e__"